import React from "react"
import autobind from "class-autobind"
import { IScheduleDocument } from "../../../../../models"
import _ from "lodash"
import * as scheduleHelper from "../../../../../helpers/scheduleHelper"
import moment from "moment"
import DonutChart from "../../../../common/donutChart/DonutChart"
import strings from "../../../../../localization/strings"
import { lightBlue400, grey300, grey400 } from "material-ui/styles/colors"
import { IDate } from "../../../../../models"
import AppStateStore from "../../../../../stores/AppStateStore"

interface IProps {
    schedules: IScheduleDocument[]
    dayLength: number
    //it's local time
    startDate: IDate
    onDayChange(selectedDay: IDate): void
}

interface IState {
    selectedDay: number
}

export default class ScheduleResourcePlannerWeekControl extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            selectedDay: 0,
        }
        autobind(this)
    }

    componentDidMount() {
        this.handleChangeSelectedDay(this.props.startDate, this.state.selectedDay)
    }

    componentWillReceiveProps(nextProps: IProps) {
        (this.props.dayLength !== nextProps.dayLength || !moment(this.props.startDate).isSame(nextProps.startDate)) &&
            this.handleChangeSelectedDay(nextProps.startDate, 0)
    }

    getDaysBySelectedDay(selectedDay: number, dayLength: number): number[] {
        const days: number[] = []
        const startDay = Math.floor(selectedDay / dayLength) * dayLength
        let endDay = Math.floor(selectedDay / dayLength) * dayLength + (dayLength - 1)
        endDay = dayLength - 1 > endDay ? endDay : dayLength - 1
        for (let i = startDay; i <= endDay; i++) {
            days.push(i)
        }
        return days
    }

    handleChangeSelectedDay(startDate: IDate, selectedDay: number) {
        const date = moment(startDate).startOf("day").add(selectedDay, "day")
        this.setState({ selectedDay: selectedDay }, () => this.props.onDayChange(date))
    }

    render() {
        const daysForSelectedDay = this.getDaysBySelectedDay(this.state.selectedDay, this.props.dayLength)
        const filledPercentArrayForSevenDays = scheduleHelper.getFilledPercentArrayForDaysByScheduleList(this.props.startDate, daysForSelectedDay, this.props.schedules)
        return (
            <div style={{ width: "100%", position: "sticky", top: AppStateStore.getTopBarHeight(), zIndex: 10, backgroundColor: "white" }}>
                {this.props.dayLength > 1 &&
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                        {daysForSelectedDay.map((day, i) =>
                            <div key={day}>
                                <div style={{ paddingBottom: 5, minHeight: 50 }}>
                                    {!Number.isNaN(filledPercentArrayForSevenDays[day]) &&
                                        <DonutChart
                                            value={filledPercentArrayForSevenDays[day]}
                                            strokeWidth={4}
                                            size={50}
                                            valuelabel={strings.Filled.toUpperCase()}
                                            textValStyle={{ fontSize: 12 }}
                                            percentStyle={{ fontSize: 10 }}
                                            textLabelStyle={{ fontSize: 8 }}
                                            spaceBetweenValAndLabel={12}
                                        />
                                    }
                                </div>
                                <div
                                    data-intercom-target={`Schedule-WeeklySchdule-SelectDay${i + 1}`}
                                    key={day}
                                    style={{
                                        backgroundColor: this.state.selectedDay === day ? lightBlue400 : grey300,
                                        color: this.state.selectedDay === day && "white",
                                        border: "1px solid",
                                        borderColor: this.state.selectedDay === day ? lightBlue400 : grey400,
                                        width: 65, height: 30, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                                        position: "relative"
                                    }}
                                    onClick={() => this.handleChangeSelectedDay(this.props.startDate, day)}
                                >
                                    <span>{moment(this.props.startDate).add(day, "day").format("ddd DD")}</span>
                                </div>
                            </div>
                        )}
                    </div>
                }
            </div>
        )
    }
}